import { render, staticRenderFns } from "./globalSearchMobile.vue?vue&type=template&id=3c824a06&scoped=true&"
import script from "./globalSearchMobile.vue?vue&type=script&lang=js&"
export * from "./globalSearchMobile.vue?vue&type=script&lang=js&"
import style0 from "./globalSearchMobile.vue?vue&type=style&index=0&id=3c824a06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c824a06",
  null
  
)

export default component.exports